export function mergeQueryParams(
	urlparams: URLSearchParams,
	params: Record<string, string | number | undefined | null>
) {
	const newParams = new URLSearchParams(urlparams.toString());
	for (const key in params) {
		if (params[key] === undefined || params[key] === null) {
			newParams.delete(key);
			continue;
		}
		newParams.set(key, params[key].toString());
	}
	return newParams.toString();
}
